export default "__VITE_ASSET__b8c47f1b__"